import { useMemo } from 'react'
import { useTranslations } from '@npco/utils-translations'
import { Box, InfoBox } from '@npco/zeller-design-system'

import { AccountBalanceAreaChart } from './AccountBalanceAreaChart'
import { accountBalanceChartTranslations } from './AccountBalanceChart.i18n'
import {
  getAccountBalanceForChart,
  getAccountBalancePlaceholderForChart,
  getLastThreeMonthsDateRange,
} from './AccountBalanceChart.utils'
import { AccountBalanceChartError } from './AccountBalanceChartError'
import { AccountBalanceChartHeader } from './AccountBalanceChartHeader'
import { AccountBalanceEmptyMessage } from './AccountBalanceEmptyMessage'
import { useAccountBalanceChartQuery } from './hooks/useAccountBalanceChartQuery'

export const AccountBalanceChart = () => {
  const t = useTranslations(accountBalanceChartTranslations)
  const dateRange = useMemo(() => getLastThreeMonthsDateRange(), [])
  const {
    accountBalances,
    error,
    refetch,
    isLoadingWithoutCache,
    isTimeZoneUndefined,
  } = useAccountBalanceChartQuery(dateRange)

  const isNoData = useMemo(
    () => accountBalances.every((balance) => balance.balance.value === '0'),
    [accountBalances]
  )

  if (error && !isLoadingWithoutCache) {
    return <AccountBalanceChartError retry={refetch} />
  }

  return (
    <>
      {!isLoadingWithoutCache && isNoData && <AccountBalanceEmptyMessage />}
      <Box pb="16px">
        <AccountBalanceChartHeader />
      </Box>
      <AccountBalanceAreaChart
        balances={
          isNoData ? [] : getAccountBalanceForChart(accountBalances, dateRange)
        }
        placeholderBalances={getAccountBalancePlaceholderForChart(dateRange)}
        isLoading={isLoadingWithoutCache}
      />
      {isTimeZoneUndefined && (
        <Box pt="32px">
          <InfoBox>
            <InfoBox.Message>{t('timeZoneWarning')}</InfoBox.Message>
          </InfoBox>
        </Box>
      )}
    </>
  )
}
